import { useEffect, useState } from "react";
import { useLang } from "@/context/LanguageContext";
import { api } from "@/lib/api";
import { Instagram, Mail, Phone, MapPin } from "lucide-react";

export default function Footer({ variant = "default" }) {
  const { tr, lang } = useLang();
  const [site, setSite] = useState({});
  useEffect(() => {
    api.get("/site-content").then((r) => setSite(r.data)).catch(() => {});
  }, []);

  return (
    <footer
      className="bg-[#1A1A1A] text-[#FDFBF7] mt-24"
      data-testid="footer"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10 py-16 grid grid-cols-1 md:grid-cols-4 gap-10">
        <div className="md:col-span-2">
          <div className="font-serif text-3xl mb-4">Lama</div>
          <p className="text-sm text-[#FDFBF7]/70 max-w-md leading-relaxed">
            {lang === "pt"
              ? "Cozinha e mercearia mediterrânica. Tábua, Coimbra — Portugal."
              : "Mediterranean kitchen & grocery. Tábua, Coimbra — Portugal."}
          </p>
        </div>

        <div>
          <div className="text-[11px] uppercase tracking-[0.25em] text-[#8C7A6B] mb-4">
            {lang === "pt" ? "Contacto" : "Contact"}
          </div>
          <ul className="space-y-2 text-sm text-[#FDFBF7]/80">
            {site.contact_email && (
              <li className="flex items-center gap-2">
                <Mail className="w-3.5 h-3.5" />
                <a href={`mailto:${site.contact_email}`} className="hover:text-white">{site.contact_email}</a>
              </li>
            )}
            {site.contact_phone && (
              <li className="flex items-center gap-2">
                <Phone className="w-3.5 h-3.5" />
                {site.contact_phone}
              </li>
            )}
            <li className="flex items-center gap-2">
              <MapPin className="w-3.5 h-3.5" />
              Tábua · Coimbra · Portugal
            </li>
          </ul>
        </div>

        <div>
          <div className="text-[11px] uppercase tracking-[0.25em] text-[#8C7A6B] mb-4">
            {lang === "pt" ? "Acompanhar" : "Follow"}
          </div>
          <ul className="space-y-2 text-sm text-[#FDFBF7]/80">
            <li className="flex items-center gap-2">
              <Instagram className="w-3.5 h-3.5" />
              {site.instagram || "@lama.tabua"}
            </li>
          </ul>
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-6 md:px-10 py-5 text-[11px] uppercase tracking-[0.2em] text-[#FDFBF7]/40 flex flex-col sm:flex-row gap-2 justify-between">
          <span>© {new Date().getFullYear()} Lama. {lang === "pt" ? "Todos os direitos reservados." : "All rights reserved."}</span>
          <span>{lang === "pt" ? "Feito com sabor em Portugal." : "Made with flavor in Portugal."}</span>
        </div>
      </div>
    </footer>
  );
}
